<template>
  <div class="training-detail-calendar-component">
    <div class="calendar-week">
      <div class="calendar-item calendar-week-item"
           v-for="item in weekList"
           :key="item.day"
      >{{ item.text }}
      </div>
    </div>
    <div class="calendar-week"
         v-for="(week, index) in dayList"
         :key="index"
    >
      <div class="calendar-item calendar-day-item"
           v-for="(item, dayIndex) in week"
           :key="dayIndex"
           @click="handleClickItem(item)"
      >
        <div class="calendar-day-item-container"
             :class="[
               toUnderline(item.status),
               item.continue ? 'continue' : '',
               item.isStartRange ? 'start-range' : '',
               item.isEndRange ? 'end-range' : '',
               item.today ? 'today' : ''
               ]"
        >
          <span class="day-text">{{ item.date }}</span>
          <ym-icon v-if="item.status === 'lock'"
                    class="icon-lock-fill"
                    name="lock-fill"
          />
          <span class="day-dot"
                v-if="item.status === 'unfinished' && !item.today"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'dayjs';
  import { humpToUnderline } from '@/utils';

  export default {
    name: 'TrainingDetailCalendar',
    data() {
      return {
        weekList: [
          { day: 0, text: '日' },
          { day: 1, text: '一' },
          { day: 2, text: '二' },
          { day: 3, text: '三' },
          { day: 4, text: '四' },
          { day: 5, text: '五' },
          { day: 6, text: '六' },
        ],
        dayList: [],
        format: 'YYYY-MM-DD',
      };
    },
    props: {
      startTime: {
        type: Number,
        required: true,
      },
      currentTime: {
        type: Number,
        required: true,
      },
      levels: {
        type: Array,
        required: true,
      },
      works: {
        type: Array,
        required: true,
      },
    },
    methods: {
      toUnderline(str) {
        return humpToUnderline(str);
      },
      initData() {
        let week = [];

        const startTrainingDay = moment(this.startTime * 1000);
        const startWeekDay = startTrainingDay.startOf('week');
        const startDiff = startTrainingDay.diff(startWeekDay, 'day');
        // 补充开始数据
        if (startDiff > 0) {
          for (let i = 0; i < startDiff; i++) {
            const date = startWeekDay.add(i, 'day');
            const item = {
              levelId: 0,
              date: date.format('D'),
              status: 'outOfTraining',
              workId: 0,
              continue: false,
              isEndRange: false,
              isStartRange: false,
              today: false,
            };
            week.push(item);
            if (week.length === this.weekList.length) {
              this.dayList.push(week);
              week = [];
            }
          }
        }

        this.levels.forEach((level, index) => {
          const date = moment(this.startTime * 1000).add(index, 'day');
          const item = {
            levelId: level.id,
            date: date.format('D'),
            status: level.status,
            workId: level.workId,
            continue: level.continue,
            isEndRange: level.isEndRange,
            isStartRange: level.isStartRange,
            today: level.today,
          };
          week.push(item);
          if (week.length === this.weekList.length) {
            this.dayList.push(week);
            week = [];
          }
        });

        const { length } = this.levels;
        const endTrainingDay = moment(this.startTime * 1000).add(length - 1, 'day');
        const endWeekDay = endTrainingDay.endOf('week');
        const endDiff = endWeekDay.diff(endTrainingDay, 'day');
        // 补充结束数据
        if (endDiff > 0) {
          for (let i = 0; i < endDiff; i++) {
            const date = endTrainingDay.add(i + 1, 'day');
            const item = {
              levelId: 0,
              date: date.format('D'),
              status: 'outOfTraining',
              workId: 0,
              continue: false,
              isEndRange: false,
              isStartRange: false,
              today: false,
            };
            week.push(item);
            if (week.length === this.weekList.length) {
              this.dayList.push(week);
              week = [];
            }
          }
        }
      },
      handleClickItem(item) {
        this.$emit('click', item);
      },
    },
    created() {
      this.initData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-calendar-component {
    padding: @size-base @size-medium;
    background-color: @color-white;
    text-align: center;
  }

  .calendar-week {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: @color-text-lighter;
    font-size: @font-size-small;
    &:not(:last-child) {
      margin-bottom: @size-medium;
    }
  }

  .calendar-item {
    flex: 1;
  }

  .calendar-week-item {
    padding-bottom: 0;
  }

  @day-size: 60px;
  .calendar-day-item-container {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: @color-text-base;
    font-size: @font-size-base;
    position: relative;
    &.out-of-training {
      font-size: @font-size-small;
      color: @color-placeholder;
    }
    &.lock {
      font-size: @font-size-small;
    }
    &.finished {
      .day-text {
        border-color: @training-primary-color-lighter;
        background-color: @training-primary-color-lighter;
        color: @training-primary-color;
      }
    }
    &.continue {
      background-color: @training-primary-color;
      &.start-range&.end-range {
        background: none;
      }
      .day-text {
        background-color: @training-primary-color;
        border-color: @training-primary-color;
        color: @color-white;
      }
    }
    &.start-range {
      border-top-left-radius: @day-size;
      border-bottom-left-radius: @day-size;
      &:not(.end-range) {
        background-image: linear-gradient(
            to left,
            @training-primary-color 50%,
            @color-white 50%
        );
      }
    }
    &.end-range {
      border-top-right-radius: @day-size;
      border-bottom-right-radius: @day-size;
      &:not(.start-range) {
        background-image: linear-gradient(
            to right,
            @training-primary-color 50%,
            @color-white 50%
        );
      }
    }
    &.today {
      &.finished {
        .day-text {
          background-color: @training-calendar-today-color;
          color: @color-white;
        }
      }
      .day-text {
        border-color: @training-calendar-today-color;
        color: @training-calendar-today-color;
      }
    }
  }

  .day-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: @day-size;
    height: @day-size;
    line-height: @day-size - @border-width-base * 2;
    border: @border-width-base @border-style-base @color-white;
    border-radius: @day-size;
    box-sizing: border-box;
  }

  @icon-size: 16px;
  .icon-lock-fill {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: @icon-size;
    color: @color-text-lighter;
  }

  @dot-size: 10px;
  .day-dot {
    flex-shrink: 0;
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: @dot-size;
    height: @dot-size;
    border-radius: @dot-size;
    background-color: @color-highlight;
  }
</style>
